<template>
  <div class="body-wrapper">
    <div class="header">
      <h1>
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        ></transition
        >Pregled svih zajednica
      </h1>
    </div>
    <div class="body">
      <div class="boxes">
        <div class="title-wrapper">
          <h4>Pregled novih i otvorenih tiketa</h4>
          <button
            class="btn btn-mod btn-primary"
            v-if="tickets && tickets.length != 0"
            @click="openAllTickets"
          >
            <span>Pogledaj sve tikete</span>
          </button>
        </div>
        <data-table
          :columns="tableTickets.tableColumns"
          :tableData="tickets"
          :options="tableTickets.tableOptions"
          :hideDefaultSort="true"
          :slotDate="'ticketDate'"
          :slotNameAction="'action'"
        ></data-table>
      </div>

      <div class="boxes">
        <div class="title-wrapper">
          <h4>Pregled budućih podsetnika</h4>
          <button
            class="btn btn-mod btn-primary"
            v-if="reminders && reminders.length != 0"
            @click="openAllReminders"
          >
            <span>Pogledaj sve podsetnike</span>
          </button>
        </div>
        <data-table
          :columns="tableReminders.tableColumns"
          :tableData="reminders"
          :options="tableReminders.tableOptions"
          :hideDefaultSort="true"
          :slotNextInstance="'nextIntance'"
          :slotNameActionCommunityReminders="'action'"
        ></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import DataTable from '@/components/community/Table';
import axios from '@/axios/axios';
import { DateTime } from 'luxon';

export default {
  components: {
    DataTable
  },
  async created() {
    this.getNewAndOpenTickets();
    const currentDate = DateTime.local();
    const allReminders = await this.getAllReminders({
      filters: {
        dateFrom: currentDate.toFormat('yyyy-MM-dd'),
        dateTo: currentDate
          .set({ year: currentDate.year + 1 })
          .toFormat('yyyy-MM-dd')
      }
    });
    if (allReminders.length > 4) {
      allReminders.splice(3, allReminders.length - 4);
    }

    allReminders.forEach(r => {
      r.type = 'dashboard';
      r.description =
        r.description.length > 25
          ? r.description.substring(0, 25) + '...'
          : r.description;
      r.title =
        r.title.length > 25 ? r.title.substring(0, 25) + '...' : r.title;
      return r;
    });
    this.reminders = allReminders;
  },
  data() {
    return {
      tableTickets: {
        tableColumns: [
          'communityName',
          'title',
          'description',
          'ticketDate',
          'action'
        ],
        tableOptions: {
          filterable: false,
          sortable: [],
          headings: {
            communityName: 'Zajednica',
            title: 'Naziv',
            description: 'Opis',
            ticketDate: 'Postavljen',
            action: 'Akcija'
          },
          texts: {
            count: '',
            noResults: 'Ne postoje tiketi'
          },
          perPage: 5
        }
      },
      tableReminders: {
        tableColumns: [
          'communityName',
          'title',
          'description',
          'nextIntance',
          'action'
        ],
        tableOptions: {
          filterable: false,
          headings: {
            communityName: 'Zajednica',
            title: 'Naziv',
            description: 'Opis',
            nextIntance: 'Sledeće izvršavanje',
            action: 'Akcije'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje podsetnici'
          },
          perPage: 5,
          sortable: []
        }
      },
      tickets: [],
      reminders: []
    };
  },

  methods: {
    ...mapMutations('modal', ['showModal']),
    ...mapActions('table', ['getAllReminders']),
    openAllTickets() {
      this.$router.push({
        name: 'tickets'
      });
    },
    openAllReminders() {
      this.$router.push({
        name: 'reminders'
      });
    },
    getNewAndOpenTickets() {
      axios
        .get(
          `tickets/user?&search=&status[]=Nov&status[]=Otvoren&status[]=U+toku`
        )
        .then(res => {
          this.tickets = [];
          this.tickets = res.data.data;
          if (this.tickets.length > 4) {
            this.tickets.splice(3, this.tickets.length - 4);
          }
          this.tickets.forEach(e => {
            let community = this.$store.getters.getCommunities.filter(
              c => c.community_id == e.community_id
            );
            e.communityName =
              community[0].address + ' ' + community[0].street_number;
            e.description =
              e.description.length > 25
                ? e.description.substring(0, 25) + '...'
                : e.description;
            e.title =
              e.title.length > 25 ? e.title.substring(0, 25) + '...' : e.title;
          });
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  h4 {
    margin-bottom: 0;
  }
}
</style>
<style lang="scss">
.body-wrapper {
  display: block;
  padding: 10px;
  // height: 100%;
}

h1,
h2 {
  text-align: center;
}
h1 {
  padding-top: 25px;
  position: relative;
}
h2 {
  color: #636363;
  padding-bottom: 20px;
}

#arrow {
  padding: 5px;
  position: absolute;
  left: 0;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.25s;
}

#arrow:hover {
  background-color: rgba(176, 178, 178, 0.5);
}

.body {
  .boxes {
    // display: flex;
    margin: 1rem 0;
    .table-class {
      width: 100%;
    }
    .full-width-box {
      flex: 2;
      // padding: 0 16px;
    }
    .box-wrapper {
      flex: 2;
      padding: 0 16px;
      max-width: 50%;
      &:first-child {
        padding: 0;
        flex: 2;
        margin-right: 20px;
      }
      &:last-child {
        padding: 0;
      }
    }
  }
  .btn-bulk {
    margin: 8px 8px 8px 0;
    height: 90%;
    padding: 6px;
    font-size: 0.9rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border-radius: 0.25rem;
    width: 360px;
    justify-content: center;
    span,
    i {
      color: #fff;
    }
    i {
      margin-left: 8px;
    }
    &.btn-mod {
      background: rgba(85, 85, 85, 1);
      &:hover {
        background: rgba(75, 75, 75, 1);
      }
    }
    &.btn-danger {
      background: rgba(220, 53, 70, 1);
      &:hover {
        background: rgba(200, 53, 70, 1);
      }
    }
  }
  .title-bulk {
    width: fit-content;
    font-weight: 600;
    font-size: 1.3rem;
    border-bottom: 1px solid gray;
  }
  .bulk-actions {
    display: flex;
    flex-wrap: wrap;
    margin-top: 16px;
  }
}
</style>
